import { GET_FAMILY_SITUATIONS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_FAMILY_SITUATIONS] (state, situations) {
    state.all = situations
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/familySituations.js